import { useMemo, useState } from 'react';

// 受控分页 hook:配合 Semi Table 的 pagination.currentPage 使用。
//
// 为什么需要它:Semi Table 在 dataSource 引用变化时,会在 componentDidUpdate 里
// 把 currentPage 硬重置为 1(源码注释:"when dataSource has change, should reset
// currentPage")。而这几个列表页都带自动刷新(令牌页 5 秒一次),每次刷新都会
// setList 出新数组 → 用户翻到第 2 页会被无声弹回第 1 页。
//
// 解决方式:把 currentPage 收到 React state 里自己管,并自己把当前页的数据切出来
// 传给 Table —— Semi 在受控模式(pagination.currentPage 不为空)下不再内部切片,
// 只负责渲染分页条,分页状态由我们持有,刷新时就不会被重置。
export function usePagedRows(list, pageSize) {
  const [page, setPage] = useState(1);
  const rows = list || [];
  const totalPage = Math.max(1, Math.ceil(rows.length / pageSize));
  // 列表变短时(例如删掉了最后几行)不要停在已经不存在的页上
  const currentPage = Math.min(page, totalPage);
  const pagedList = useMemo(
    () => rows.slice((currentPage - 1) * pageSize, currentPage * pageSize),
    [rows, currentPage, pageSize]
  );
  return { page: currentPage, totalPage, pagedList, setPage };
}
